import React, { useEffect, useState } from "react"
// import styles from "./style.module.css"
import * as styles from "./style.module.css"

const UnderlineComponent = ({ children }) => {
  const [isUnderlined, setIsUnderlined] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        const element = document.getElementById("underline-element")
        if (element) {
          const rect = element.getBoundingClientRect()
          const windowHeight = window.innerHeight

          if (windowHeight > rect.top + 200 && !isUnderlined) {
            setIsUnderlined(true)
          }
        }
      }

      window.addEventListener("scroll", handleScroll)
      return () => window.removeEventListener("scroll", handleScroll)
    }
  }, [isUnderlined])

  return (
    <span
      id="underline-element"
      className={`${styles.underlineBefore} ${
        isUnderlined ? styles.underlineAfter : ""
      }`}
    >
      {children}
    </span>
  )
}

export default UnderlineComponent
